export const IncreaseType = {
    DAY_INCREASE: 'dayIncrease',
    WEEK_INCREASE: 'weekIncrease',
    MONTH_INCREASE: 'monthIncrease',
    HALF_YEAR_INCREASE: 'halfYearIncrease',
    YEAR_INCREASE: 'yearIncrease',
    YTD_INCREASE: 'ytdIncrease'
};

export const IncreaseTypeMap = {
    dayIncrease: '今日升幅',
    weekIncrease: '近一週',
    monthIncrease: '近一月',
    halfYearIncrease: '近半年',
    yearIncrease: '近一年',
    ytdIncrease: '今年以來',
};

export const SupportType = [
    IncreaseType.DAY_INCREASE,
    // IncreaseType.WEEK_INCREASE,
    // IncreaseType.MONTH_INCREASE,
    // IncreaseType.YEAR_INCREASE,
];

export const IncreaseTypeOption = Object.keys(IncreaseTypeMap).map((key) => ({
    value: key,
    label: IncreaseTypeMap[key]
}));

export const MarketId = {
    US: 2,
    SG: 4,
    AU: 5,
    HK: 1,
    SHSZ: 3,
    JP: 7
};

export const PlateId = {
    HK_ALL: 10001910,
    US_ALL: 200306,
    AUS_ALL: 10005910,
    JP_ALL: 10007910,
    SGX_ALL: 10003910,
    CN_ALL: 9700609,
    CN_HS_A: 3000005,
    // 剔除 OTC 的美股市值榜单
    US: 10002920,
    // 日本 ETF 活跃榜
    JP_ETF: 10007799
};

export const PlateMap = {
    [MarketId.HK]: PlateId.HK_ALL,
    [MarketId.US]: PlateId.US,
    [MarketId.JP]: PlateId.JP_ALL,
    [MarketId.SHSZ]: PlateId.CN_ALL,
    [MarketId.AU]: PlateId.AUS_ALL,
    [MarketId.SG]: PlateId.SGX_ALL
};

// 热度榜消费的类型
export const SortId = {
    // 交易热度
    TRADE: 11,
    // 搜索热度
    SEARCH: 13,
    // 资讯热度
    NEWS: 15,
    // 综合热度
    AVERAGE: 17
};

// 用于标志是否为板块消费的市值榜
export const MARKET_VAL = 'market-val';

// 用于标志是否为板块消费的日股EFT榜
export const JP_ETF = 'jp-etf';
